import { render, staticRenderFns } from "./conversational.view.vue?vue&type=template&id=102f8cb4&scoped=true"
import script from "./conversational.view.vue?vue&type=script&lang=ts"
export * from "./conversational.view.vue?vue&type=script&lang=ts"
import style0 from "./conversational.view.vue?vue&type=style&index=0&id=102f8cb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102f8cb4",
  null
  
)

export default component.exports